import { render, staticRenderFns } from "./roleUser.vue?vue&type=template&id=5539c912&scoped=true&"
import script from "./roleUser.vue?vue&type=script&lang=js&"
export * from "./roleUser.vue?vue&type=script&lang=js&"
import style0 from "./roleUser.vue?vue&type=style&index=0&id=5539c912&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5539c912",
  null
  
)

export default component.exports